/** Hover previews for the quick-view gallery. Click and touch keep existing behavior. */
class SQuickViewGallery extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const track = this.querySelector('[data-qv-track]');
    if (!track) return;
    this.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const thumb = event.target.closest('[data-qv-thumb]');
      if (!thumb || !this.contains(thumb)) return;
      if (event.relatedTarget && thumb.contains(event.relatedTarget)) return;
      const index = Number(thumb.dataset.qvThumb);
      const slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.children[0].offsetLeft, behavior: 'instant' });
      this.querySelectorAll('[data-qv-thumb]').forEach((button) => {
        button.setAttribute('aria-current', String(button === thumb));
      });
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-quick-view-gallery')) {
  customElements.define('s-quick-view-gallery', SQuickViewGallery);
}
